import type { ReceivedResellerAuthorization } from '../../../../modules/receivedResellerAuthorization/reducer'
import { useStyles } from './AddEditChannelOfferHeader.styles'

export const AddEditChannelOfferHeader = ({
  resellerAuthorization,
}: {
  resellerAuthorization?: ReceivedResellerAuthorization
}) => {
  const { classes } = useStyles()
  return (
    <div
      className={classes.productNameWrapper}
      data-testid="authorization-name-section"
    >
      <div className={classes.textContainer}>
        <div className={classes.sectionText}>Reseller authorization</div>
        <div
          className={classes.sectionHeading}
          data-testid="authorization-name"
        >
          {resellerAuthorization?.agreementName}
        </div>
      </div>
    </div>
  )
}
